import React from "react";
import moment from "moment";
import { Label, Row, Col } from "reactstrap";
import { LOGO,LOGO2,LOGO3,FACEBOOK,TIKTOK,INSTAGRAM, LOGO_2 } from "./../Componentes/Image";
import {format_miles, FORMATO_AM_PM, roundNumber} from "./../Componentes/Util";
import { ReactBarcode } from 'react-jsbarcode';
import { imgURLocalImage, LOGO_COTIZACION_2_ENABLE, LOGO_COTIZACION_3_ENABLE } from "../Componentes/Services";
import {MDBTable, MDBTableHead, MDBTableBody,  MDBRow,MDBCol} from "mdb-react-ui-kit";
import Decimal from "decimal.js";
import {MDBInput} from "mdb-react-ui-kit";
import { useEffect, useRef } from "react";
import { useReactToPrintAdvanced } from "react-to-print-advanced";

function abrirVistaPreviaTicket(htmlTicket) {
  const win = window.open("", "_blank");

  win.document.write(`
    <html>
      <head>
        <title>Vista previa</title>

        <style>
          @page {
            size: 80mm auto;
            margin: 0;
          }

          html, body {
            width: 80mm;
            margin: 0;
            padding: 0;
          }

          body {
            font-family: monospace;
            font-size: 12px;
            background: #f5f5f5;
          }

          .ticket {
            width: 80mm;
            padding: 4mm;
            box-sizing: border-box;
            background: white;
          }

          .center {
            text-align: center;
          }

          .line {
            border-top: 1px dashed #000;
            margin: 6px 0;
          }

          .btn-print {
            width: 100%;
            padding: 12px;
            font-size: 16px;
            border: none;
            background: #000;
            color: #fff;
            margin-top: 10px;
            cursor: pointer;
          }

          @media print {
            body {
              background: white;
            }

            .btn-print {
              display: none;
            }
          }
        </style>
      </head>

      <body>
        <div class="ticket">
          ${htmlTicket}
        </div>

        <button class="btn-print" onclick="window.print()">
          🖨️ Imprimir
        </button>
      </body>
    </html>
  `);

  win.document.close();
}
function pad(text, length, char = " ", dir = "right") {
  text = String(text);
  if (text.length >= length) return text.slice(0, length);
  const fill = char.repeat(length - text.length);
  return dir === "right" ? text + fill : fill + text;
}
const printReceipt_bluetooth = (data) => {
  console.log(data)


    const fPagoMap = {
    "01": "CRÉDITO",
    "02": "EFECTIVO",
    "03": "TARJETA DE CRÉDITO",
    "04": "TARJETA DÉBITO",
    "05": "TARJETA FIDELIZACIÓN",
    "06": "VALE",
    "07": "TARJETA DE REGALO",
    "08": "Transf/Depósito Bancario",
    "09": "Cheque",
    "99": "OTRO"
  };

  const line = "------------------------------------------------";

  let html = "";

  // ===== ENCABEZADO =====
  html += `
    <div class="center">
      <div><strong>DGI</strong></div>
      <div>Comprobante auxiliar de factura electrónica</div>
    </div>
  `;

  // if (data.tipoDocumento === "01") {
  //   html += `<div class="center">FACTURA DE OPERACIÓN INTERNA</div>`;
  // }
  // if (data.tipoDocumento === "04") {
  //   html += `<div class="center">NOTA DE CRÉDITO REFERENTE A UNA FE</div>`;
  // }

  // html += `
  //   <div class="center">
  //     <div>${data.dataCompany.com_nombre}</div>
  //     <div>${data.dataCompany.com_ruc} DV ${data.dataCompany.com_dv}</div>
  //     <div>${data.dataCompany.com_direccion}</div>
  //     <div>TEL: ${data.dataCompany.com_telefono}</div>
  //   </div>

  //   <div>${line}</div>
  // `;

  // // ===== CLIENTE =====
  // html += `
  //   <div>CLIENTE: ${data.cli_name}</div>
  //   <div>DOCUMENTO NO: ${data.fac_docn}</div>
  //   <div>FECHA: ${data.fac_fecha}</div>
  //   <div>SUCURSAL: ${data.codigoSucursalEmisor}</div>
  //   <div>PUNTO DE FACTURACIÓN: 001</div>

  //   <div>${line}</div>
  //   <div>ARTICULO             CANT     PRECIO     TOTAL</div>
  //   <div>${line}</div>
  // `;

  // // ===== ITEMS =====
  // // const items = Array.isArray(data.listaItems)
  // //   ? data.documento.xFe.rFE.gItem
  // //   : [data.documento.xFe.rFE.gItem];

  // data.listaItems.forEach(it => {
  //   html += `
  //     <div>${it.descripcion}</div>
  //     <div>
  //       ${pad(it.codigo, 20)}
  //       ${pad(it.cantidad, 8)}
  //       $${pad(it.precioUnitario, 8)}
  //       $${it.valorTotal}
  //     </div>
  //   `;
  // });

  // // ===== TOTALES =====
  // html += `
  //   <div>${line}</div>
  //   <div>SUBTOTAL: $${data.totalPrecioNeto}</div>
  //   <div>ITBMS:    $${data.totalTodosItems}</div>
  //   <div><strong>TOTAL:    $${data.totalFactura}</strong></div>
  //   <div>ENTREGADO:$${data.totalValorRecibido}</div>
  //   <div>CAMBIO:   $${data.vuelto}</div>
  //   <div>${line}</div>
  // `;

  // // ===== FORMA DE PAGO =====
  // html += `<div class="center">FORMA DE PAGO</div>`;


  // data.listaFormaPago.forEach(p => {
  //   const desc = fPagoMap[p.formaPagoFact] || p.descFormaPagoR;
  //   html += `<div>${pad(desc, 30)} $${p.valorCuotaPagada}</div>`;
  // });
  // abrirVistaPreviaTicket(html);
}; 
// function imprimirFacturaHTML(data) {



//   return html;
// }
 class ComponentToPrintss extends React.Component {
    render() {
      var props = this.props.props;
      var formCompra = this.props.formCompra;
      var formCompania = this.props.formCompania;
      var subtotal = 0;
      var itbms = 0;
      var total = 0;
      return (
        <React.Fragment>
          <Row key={new Date().toString()} className="datatable-rep">
            <Col xs={12}>
              <Row className="mt-2 border-rep-bot mb-3">
                <Col xs={3} className="text-center">
                  <img alt="" className="logo-rep" src={LOGO}></img>
                </Col>
                <Col xs={6} className="text-start">
                  <Label className="title-re">{formCompania.com_nombre}</Label><br></br>
                  <Label className="title-rep2">{"R.U.C. "+formCompania.com_ruc + " D.V. "+formCompania.com_dv}</Label><br></br>
                  <Label className="title-rep2">{formCompania.com_telefono + " / "+formCompania.com_email}</Label>
                  <Label className="title-rep2">{formCompania.com_direccion}</Label><br></br>
                </Col>
                <Col xs={3} className="text-end">
                 <Label className="title-rep3">N° {formCompra.dc_docn}</Label><br></br>
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="text-start mb-2">
                  <Label className="title-re">FACTURA DE COMPRA</Label><br></br>
                  <Label className="title-rep2"># DE DOCUMENTO : {formCompra.dc_docn}</Label><br></br>
                  <Label className="title-rep2">PROVEEDOR : {formCompra.prov_proveedor}</Label><br></br>
                  <Label className="title-rep2">BODEGA : {formCompra.bod_nombre}</Label><br></br>
                  <Label className="title-rep2">DESCRIPCIÓN: {formCompra.dc_descripcion}</Label><br></br>
                  <Label className="title-rep2">FECHA DOCUMENTO PROCESADO: {formCompra.dc_fecha_procesado}</Label><br></br>
                </Col>
              </Row>
            </Col>
            <Col xs={12} className="text-center padding-print-body">
              <MDBTable striped className="custom-table">
                <MDBTableHead dark>
                  <tr>
                    <th className="text-center w-300px">CÓDIGO</th>
                    <th className="text-center w-300px">DESCRIPCIÓN</th>
                    <th className="text-center w-300px">CANTIDAD</th>
                    <th className="text-center w-300px">PRECIO</th>
                    <th className="text-center w-250px">ITBMS</th>
                    <th className="text-center w-500px">TOTAL</th>
                  </tr>
                </MDBTableHead>
                <MDBTableBody className="datatable-body">
                  {props.map((data, i) => {
                    subtotal =Number(subtotal) + Number(Number(data.dcd_cantidad) * Number(data.dcd_precio));
                    itbms = Number(itbms) + Number(data.dcd_itbms);
                    total = Number( subtotal) + Number(itbms);

                    return (
                      <tr key={i}>
                        <td className="text-start">
                          <Label>{data.art_upc}</Label>
                        </td>
                        <td className="text-start">
                          <Label>{data.art_descripcion}</Label>
                        </td>
                        <td className="text-center">
                          <Label>{data.dcd_cantidad}</Label>
                        </td>
                        <td className="text-center">
                          <Label>{data.dcd_precio}</Label>
                        </td>
                        <td className="text-center">
                          <Label>{Number(data.dcd_itbms).toFixed(2)}</Label>
                        </td>
                        <td className="text-center">
                          <Label className="fw-bold">{Number(data.dcd_total).toFixed(2)}</Label>
                        </td>
                      </tr>
                    );
                  })}
                  <tr className="border-0">
                    <td className="text-left font-weight-bold border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0">
                      <Label className="fw-bold">SUBTOTAL</Label>
                    </td>
                    <td className="text-center border-0">
                      <Label className="fw-bold">{subtotal.toFixed(2)}</Label>{" "}
                    </td>
                  </tr>
                  <tr className="border-0">
                    <td className="text-left font-weight-bold border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0">
                      <Label className="fw-bold">ITBMS</Label>
                    </td>
                    <td className="text-center border-0">
                      <Label className="fw-bold">{itbms.toFixed(2)}</Label>{" "}
                    </td>
                  </tr>
                  <tr className="border-0">
                    <td className="text-left font-weight-bold border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0">
                      <Label className="fw-bold">TOTAL</Label>
                    </td>
                    <td className="text-center border-0">
                      <Label className="fw-bold">{total.toFixed(2)}</Label>{" "}
                    </td>
                  </tr>
                </MDBTableBody>
              </MDBTable>
            </Col>
          </Row>
        </React.Fragment>
      );
    }
  }
   class Componentprint_report_x extends React.Component {
    render() {
      var props = this.props.props;
      var fecha = this.props.state;

      return (
        <React.Fragment>
          <Row key={new Date().toString()} className="datatable-rep">
            <Col xs={12}>
              <Row className="mt-2 border-rep-bot mb-3">
                <Col xs={4} className="text-center">
                  <img alt="" className="logo-rep" src={LOGO}></img>
                </Col>
                <Col xs={8} className="text-start">
                  <Label className="title-re">{props.compania[0].com_nombre}</Label><br></br>
                  <Label className="title-rep2">{"R.U.C. "+props.compania[0].com_ruc + " D.V. "+props.compania[0].com_dv}</Label><br></br>
                  <Label className="title-rep2">{props.compania[0].com_telefono + " / "+props.compania[0].com_email}</Label>
                  <Label className="title-rep2">{props.compania[0].com_direccion}</Label><br></br>
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="text-start mb-2">
                  <Label className="title-re">INFORME DE VENTAS</Label><br></br>
                  <Label className="title-rep2">Fecha: {moment(fecha[0].startDate).format("YYYY-MM-DD")} - {moment(fecha[0].endDate).format("YYYY-MM-DD")}</Label><br></br>
                </Col>
              </Row>
            </Col>
            <Col xs={12} className="text-center padding-print-body">
            <Row>
              <Col xs={12}><Label className="title-informe">ANULACIONES</Label></Col>
             {props.length !==0?props.anulacion.map((data)=>{
                          return <>
                          <Col xs={12}>
                          <Row>
                            <Col xs={4} md={3} className="input-tablet mt-2">
                              <MDBInput
                                id="fac_id"
                                wrapperClass="mb-2"
                                label="# Factura"
                                name="fac_id"
                                value={data.fac_id.toString().padStart(10, "0")}
                                disabled={true}/>
                            </Col>
                            <Col xs={4} md={3}className="input-tablet  mt-2">
                                <MDBInput
                                  id="fac_fecha"
                                  wrapperClass="mb-2"
                                  label="Fecha factura"
                                  name="fac_fecha"
                                  value={data.fac_fecha}
                                  disabled={true}/>
                            </Col>
                            <Col xs={4} md={3}className="input-tablet mt-2">
                                <MDBInput
                                  id="fac_date_anulacion"
                                  wrapperClass="mb-2"
                                  label="Fecha anulación"
                                  name="fac_date_anulacion"
                                  value={data.fac_date_anulacion}
                                  disabled={true}/>
                            </Col>
                            <Col xs={4}  md={3}className="input-tablet mt-2">
                                <MDBInput
                                  id="fcd_total"
                                  wrapperClass="mb-2"
                                  label="Monto"
                                  name="fcd_total"
                                  value={Number(data.fcd_total).toFixed(2)}
                                  disabled={true}/>
                            </Col>
                            <Col xs={8} className="input-tablet mt-2">
                                <MDBInput
                                  id="fac_motivo_anulacion"
                                  wrapperClass="mb-2"
                                  label="Motivo de la anulación"
                                  name="fac_motivo_anulacion"
                                  value={data.fac_motivo_anulacion}
                                  disabled={true}/>
                            </Col>  
                            </Row></Col>
                
                            </>
                          }):""}
            </Row>
            <Row>
               <Col xs={12}><Label className="title-informe">VENTAS REGISTRADAS</Label></Col>
                        {props.length !==0?props.montos_fpago.map((data)=>{
                        return <>
                          <Col xs={9} className="input-tablet mt-2">
                            <MDBInput
                              id="fcfp_fpago"
                              wrapperClass="mb-2"
                              label="Forma de pago"
                              name="fcfp_fpago"
                              value={data.fcfp_fpago}
                              disabled={true}/>
                          </Col>
                          <Col xs={3} className="input-tablet mt-2">
                            <MDBInput
                              id="fcfp_monto"
                              wrapperClass="mb-2"
                              label="Monto"
                              name="fcfp_monto"
                              value={Number(data.fcfp_monto).toFixed(2)}
                              disabled={true} />
                          </Col>
                        </>
                      }):""}
                    </Row>
                    <Row>
                      <Col xs={12}><Label className="title-informe">TOTALES</Label></Col>
                    <Col xs={4} className="input-tablet">
                      <MDBInput
                        id="usr_nombre"
                        wrapperClass="mb-2"
                        label="NOMBRE"
                        name="usr_nombre"
                        value={props.length !==0?props.montos_totales[0].usr_nombre:"0.00"}
                        disabled={true}/>
                    </Col>
                    <Col xs={2} className="input-tablet">
                      <MDBInput
                        id="fac_caja"
                        wrapperClass="mb-2"
                        label="CAJA"
                        name="fac_caja"
                        value={props.length !==0?props.montos_totales[0].fac_caja:"0.00"}
                        disabled={true}/>
                    </Col>
                    <Col xs={3} className="input-tablet">
                      <MDBInput
                        id="montos_itbms"
                        wrapperClass="mb-2"
                        label="I.T.B.M.S"
                        name="montos_itbms"
                        value={props.length !==0?Number(props.montos_totales[0].fcd_itbms).toFixed(2):"0.00"}
                        disabled={true}/>
                    </Col>
                    <Col xs={3} className="input-tablet">
                      <MDBInput
                        id="montos_totales"
                        wrapperClass="mb-2"
                        label="Totales"
                        name="montos_totales"
                        value={props.length !==0?Number(props.montos_totales[0].fcd_total).toFixed(2):"0.00"}
                        disabled={true}/>
                    </Col>
                    
                    </Row>
            </Col> 
          </Row>
        </React.Fragment>
      );
    }
  }
  class ComponentToPrintsPDFCredito extends React.Component {
    render() {
      var form = this.props.form;
      var dataCompania = this.props.dataCompania;
      return (
        <React.Fragment>
          <Row key={new Date().toString()} className="datatable-report font-size14 ov-flow-credito">
            <Col xs={2} className="text-center">
              <img alt="" className="width-logo-cre" src={LOGO}></img>
            </Col>
            <Col xs={10} className="text-right title-reporte">
              {/* <Label className="font-weight-bold">{dataCompania.com_nombre}</Label><br></br> */}
              <Label className="font-weight-bold"> {"RUC: "+dataCompania.com_ruc + " DV "+dataCompania.com_dv}</Label><br></br>
              <Label>{dataCompania.com_direccion}</Label><br></br>
              <Label >{dataCompania.com_telefono2.length>0?dataCompania.com_telefono+" / "+dataCompania.com_telefono2:dataCompania.com_telefono}</Label><br></br>
              <Label>{dataCompania.com_email}</Label>
            </Col>
            <Col xs={12} className="title-reporte3">
              <Label className="text-left fw-bolder padd-mar-u">ABONO A CRÉDITO</Label>
            </Col>
            <Col xs={8} className="text-start padding-print-body title-reporte2">
              <Label>Cliente : {form.formPagoCredito.cli_name}</Label><br></br>
              <Label>TEL : {form.formPagoCredito.cli_telefono}</Label><br></br>
              <Label>RUC : {form.formPagoCredito.cli_ruc}</Label><br></br>
              <Label className="fw-bold">FACTURA N° {form.formPagoCredito.fac_id.toString().padStart(7, "0")} </Label><br></br>
              <Label className="fw-bold">Información: {form.dataCreditosFactura.fac_factura[0].fac_text_invoice} </Label>
            </Col>
            <Col xs={4} className=" title-reporte padding-print-body">
              {LOGO_COTIZACION_2_ENABLE &&<img alt="" className="width-logo-cred2" src={LOGO2}></img>}<br></br>
              <Label> Fecha:  {moment(new Date()).format("YYYY-MM-DD")}</Label>
            </Col> 
            <Col xs={12} className="padding-print-body">
              <table className="table table-bordered margin-bb-u">
                <thead>
                  <tr>
                    <th className="text-center w-300px">Código</th>
                    <th className="text-center w-300px">Descripción</th>
                    <th className="text-center w-300px">Precio</th>
                    <th className="text-center w-300px">Cantidad</th>
                    <th className="text-center w-300px">ITBMS</th>
                    <th className="text-center w-300px">Total</th>
                  </tr>
                </thead>
                <tbody className="tbody-print">
                  {form.dataCreditosFactura.fcd_factura_detalle.map((data, i) => {
                    return (
                      <tr key={i} className={ i % 2 === 0 ? "bg-f5": ""}>
                        <td className="text-left">
                          <Label>{data.art_upc}</Label>
                        </td>
                        <td className="text-left">
                          <Label>{data.fcd_art_descripcion}</Label>
                        </td>
                        <td className="text-left">
                          <Label>${Number(data.fcd_precio).toFixed(2)}</Label>
                        </td>
                        <td className="text-left">
                          <Label>${Number(data.fcd_cantidad).toFixed(2)}</Label>
                        </td>
                        <td className="text-left">
                          <Label>${Number(data.fcd_itbms).toFixed(2)}</Label>
                        </td>
                        <td className="text-center">
                          <Label>${Number(data.fcd_total).toFixed(2)}</Label>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Col> 

             <Col xs={12}>
              <Row className="text-left">
                      <Col xs={8}></Col>
                      <Col xs={4} className="text-left mt-3">
                        <Label className="fw-bold padd-mar-u">FORMA DE PAGO</Label>
                      </Col>
                      <Col xs={8}>
              
                       </Col>
                      <Col xs={4}>
                        <table className="table table-bordered margin-bb-u">
                          <thead>
                            <tr>
                              <th className="text-center w-300px">FORMA DE PAGO</th>
                              <th className="text-center w-300px">MONTO</th>
                            </tr>
                          </thead>
                          <tbody className="tbody-print">
                            {form.dataCreditosFactura.fcfp_factura_fpago.map((data, i) => {
                              return (
                                <tr key={i} className={ i % 2 === 0 ? "bg-f5": ""}>
                                  <td className="text-left">
                                    <Label>{data.fcfp_fpago}</Label>
                                  </td>
                                  <td className="text-left">
                                    <Label>$ {Number(data.fcfp_monto).toFixed(2)}</Label>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </Col>

                      <Col xs={8}></Col>
                      <Col xs={4}>
                      <Row className="text-left">
                        <Col xs={12} className="text-left mt-3">
                          <Label className="fw-bold padd-mar-u">ABONO A CRÉDITO</Label>
                        </Col>
                        <Col xs={12}>
                        <table className="table table-bordered margin-bb-u">
                          <thead>
                            <tr>
                              <th className="text-center w-300px"># DE RECIBO</th>
                              <th className="text-center w-300px">FECHA</th>
                              <th className="text-center w-300px">MONTO</th>
                            </tr>
                          </thead>
                          <tbody className="tbody-print">
                            {form.dataCreditosPago.map((data, i) => {
                              return (
                                <tr key={i} className={ i % 2 === 0 ? "bg-f5": ""}>
                                  <td className="text-center">
                                    <Label>{data.crp_id}</Label>
                                  </td>
                                  <td className="text-left">
                                    <Label>{data.crp_fecha}</Label>
                                  </td>
                                  <td className="text-left">
                                    <Label>$ {Number(data.crp_monto).toFixed(2)}</Label>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                        </Col>
                      </Row>
                      </Col>
                      <Col xs={8}></Col>
                      <Col xs={4}>
                      </Col>
                      <Col xs={8}></Col>
                      <Col xs={4} className="text-left mt-3">
                       
                      </Col>
                      <Col xs={8}>
              
                       </Col>
                      <Col xs={4}>
                        <table className="table table-bordered margin-bb-u">
                          <thead>
                            <tr>
                              <th className="text-center w-300px">SALDO AL CRÉDITO</th>
                              <th className="text-center w-300px">$ {form.saldo}</th>
                            </tr>
                          </thead>
                        </table>
                      </Col>
                </Row>
              
            </Col> 
            <Col xs={12} className="text-center">
              {LOGO_COTIZACION_3_ENABLE&&<img alt="" className="width-logo-cot3" src={LOGO3}></img>}
            </Col>
          </Row>
        </React.Fragment>
      );
    }
  }
   class ComponentToPrintsCotizacion extends React.Component {
    render() {
      var flagImg=false;
      var props = this.props.props;
      var form = this.props.form;
      var dataCompania = this.props.dataCompania;
      var subtotal = 0;
      var itbms = 0;
      var total = 0;
      props.find((data,i)=>{
        if(data.art_img==="1"){
          flagImg=true;
        return true
        }
        return null
      });

      return (
        <React.Fragment>
          <Row key={new Date().toString()} className="datatable-report font-size14">
            <Col xs={2} className="text-center">{dataCompania.com_logo==="1"?<img alt="" className="width-logo-cot" src={LOGO}></img>:<img alt="" className="width-logo-cot" src={LOGO_2}></img>}</Col>
            <Col xs={10} className="text-right title-reporte">
              <Label className="font-weight-bold">{dataCompania.com_nombre}</Label><br></br>
              <Label className="font-weight-bold">{"RUC: "+dataCompania.com_ruc + " DV "+dataCompania.com_dv}</Label><br></br>
              <Label>{dataCompania.com_direccion}</Label><br></br>
              <Label >{dataCompania.com_telefono2.length>0?dataCompania.com_telefono+" / "+dataCompania.com_telefono2:dataCompania.com_telefono}
              </Label><br></br>
              <Label>{dataCompania.com_email}</Label>
            </Col>
            <Col xs={12} className="text-center">
            <Label className="fs-16 padd-mar-u">Cotización valida por 15 días</Label></Col>
            <Col xs={12} className="title-reporte3">
            <Label className="text-center fw-bolder padd-mar-u">COTIZACIÓN </Label>
            </Col>
            <Col xs={8} className="text-start padding-print-body title-reporte2">
              <Label className="fw-bolder">COTIZACIÓN N° {form.cot_id.toString().padStart(7, "0")}</Label>
              <br></br>
              <Label>Cliente : {form.cot_nombre}</Label>
              <br></br>
              <Label>TEL : {form.cli_telefono}</Label>
              <br></br>
              <Label>RUC: {form.cli_ruc} {form.cli_dv}</Label>
              <br></br>
              <Label>Descripción : {form.cot_descripcion}</Label>
            </Col>
            <Col xs={4} className=" title-reporte padding-print-body d-table-c">{LOGO_COTIZACION_2_ENABLE &&<img alt="" className="width-logo-cot2" src={LOGO2}></img>}
              <Label>Fecha:  {form.cot_fecha}</Label><br></br><Label>Elaborado por: {form.cot_vendedor_name}</Label>
            </Col>
            <Col xs={12} className="padding-print-body">
              <table className="table table-bordered margin-bb-u ">
                <thead>
                  <tr>
                    { dataCompania.com_cot_image==="1"?flagImg?<th className="text-center w-300px">Imagen</th>:null:null}
                    <th className="text-center w-300px">Código</th>
                    <th className="text-center w-300px">Descripción</th>
                    <th className="text-center w-300px">Precio</th>
                    <th className="text-center w-300px">Cantidad</th>
                    <th className="text-center w-300px">Desc.</th>
                    <th className="text-center w-250px">ITBMS</th>
                    <th className="text-center w-500px">Total</th>
                  </tr>
                </thead>
                <tbody className="tbody-print">
                  {props.map((data, i) => {
                    subtotal = Number(subtotal) + Number(Number(data.cotd_total) - Number(data.cotd_itbms));
                    itbms = Number(itbms) + Number(data.cotd_itbms);
                    total =   Number(total) +Number(data.cotd_total);
                    subtotal = roundNumber(subtotal,2);
                    itbms = roundNumber(itbms,2);
                    total = roundNumber(total,2);
                    return (
                      <tr key={i} className="border-unset-cot text-left-c">
                        {dataCompania.com_cot_image==="1"?flagImg? <td className="text-center border-unset-cot">{data.art_img==="1"? <img alt ="" className="img-art-datatable-cotizacion"  src ={imgURLocalImage+data.art_imgName} />:null}</td>:null:null}
                        <td className="text-left width-96px border-unset-cot"><Label>{data.art_upc}</Label></td>
                        <td className="text-left border-unset-cot"><Label>{data.art_descripcion}</Label></td>
                        <td className="text-right label-padding-r width-95px border-unset-cot"><Label>${Number(data.cotd_total)<1000?(Math.round(new Intl.NumberFormat('es-MX').format(data.cotd_precio) * 100) / 100).toFixed(2): new Intl.NumberFormat('es-MX').format(Number(data.cotd_precio).toFixed(2)) }</Label></td>
                        <td className="text-center width-95px border-unset-cot"><Label className="text-center">{data.cotd_cantidad}</Label></td>
                        <td className="text-right  label-padding-r width-95px border-unset-cot"><Label className="text-center">${ Number(data.cotd_descuento).toFixed(2)}</Label></td>
                        <td className="text-right label-padding-r width-95px border-unset-cot"><Label className="text-right">${ Number(data.cotd_total)<1000?(Math.round(new Intl.NumberFormat('es-MX').format(data.cotd_itbms) * 100) / 100).toFixed(2): new Intl.NumberFormat('es-MX').format(Number(data.cotd_itbms).toFixed(2))  }</Label></td>
                        <td className="text-right label-padding-r width-95px border-unset-cot"><Label className="fw-bold">${Number(data.cotd_total)<1000?(Math.round(new Intl.NumberFormat('es-MX').format(data.cotd_total) * 100) / 100).toFixed(2): new Intl.NumberFormat('es-MX').format(Number(data.cotd_total).toFixed(2))}</Label></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              </Col>
              <Row className="mt-2">
                <Col xs={12} className="text-center fs-12px fixed-div-cot ">
                    <Row>
                      <Col xs={9} className="title-reporte2"><pre>{form.cot_garantia}<br></br>{dataCompania.com_cotizacion_info}</pre></Col>
                      <Col xs={3} >
                        <div className="border-2px-solid">
                          <Label className="fw-bold ">SUBTOTAL:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  </Label>
                          <Label className="fw-bold cot-label-pr">${Number(subtotal)<1000?(Math.round(new Intl.NumberFormat('es-MX').format(subtotal) * 100) / 100).toFixed(2):new Intl.NumberFormat('es-MX').format(Number(subtotal).toFixed(2)) }</Label><br></br>
                          <Label className="fw-bold">ITBMS:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;     </Label>
                          <Label className="fw-bold cot-label-pr">${Number(itbms)<1000?(Math.round(new Intl.NumberFormat('es-MX').format(itbms) * 100) / 100).toFixed(2):new Intl.NumberFormat('es-MX').format(Number(itbms).toFixed(2)) }</Label><br></br>
                          <Label className="fw-bold">TOTAL: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    </Label>
                          <Label className="fw-bold cot-label-pr">${Number(total)<1000?(Math.round(new Intl.NumberFormat('es-MX').format(total) * 100) / 100).toFixed(2):new Intl.NumberFormat('es-MX').format(Number(total).toFixed(2)) }</Label>
                        </div>
                      </Col>
                    </Row>
                  <Row>
                    <Col xs={12}>{LOGO_COTIZACION_3_ENABLE&&<><Label>Confeccionado por: <img alt="" className="width-logo-cot3" src={LOGO3}></img></Label></>}</Col>
                    <Col xs={1}></Col>
                    <Col xs={10} className="text-center">
                      <MDBRow className="mb-3">
                          {dataCompania.com_instagram.length>0&& <MDBCol><img alt="" className="width-logo-cot4" src={INSTAGRAM}></img><Label>{dataCompania.com_instagram}</Label></MDBCol> }
                          {dataCompania.com_facebook.length>0&&<MDBCol><img alt="" className="width-logo-cot4" src={FACEBOOK}></img><Label>{dataCompania.com_facebook}</Label></MDBCol>}
                          {dataCompania.com_tiktok.length>0&&<MDBCol><img alt="" className="width-logo-cot4" src={TIKTOK}></img><Label>{dataCompania.com_tiktok}</Label></MDBCol>}
                      </MDBRow>
                    </Col>
                    <Col xs={1}></Col>
                  </Row>
                </Col>
              </Row>
          </Row>
        </React.Fragment>
      );
    }
  }
  class ComponentToPrintsGastos extends React.Component {
    render() {
      var dataReporteGastos = this.props.dataReportGastos;
      var formCompania = this.props.formCompania;
      return (
        <React.Fragment>
          <Row key={new Date().toString()} className="datatable-report">
            <Col xs={12} className="text-center">
              <img alt="" className="width-logo" src={LOGO}></img>
            </Col>
            <Col xs={12} className="text-center mt-4 mb-2">
              <h3 className="font-weight-bold">{formCompania.com_nombre}</h3>
              <h7>{formCompania.com_direccion}</h7>
              <br></br>
              <h7 className="font-weight-bold">
                {"RUC: " + formCompania.com_ruc + " DV " + formCompania.com_dv}
              </h7>
              <br></br>
              <h7 className="font-weight-bold">{"TEL: " + formCompania.com_telefono}</h7>
            </Col>
            <Col xs={12} className="text-start">
              <h5 className="text-center ">REPORTE DE GASTOS </h5>
            </Col>

            <Col xs={12} className="text-center padding-print-body">
              <table className="table table-bordered  ">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>SUCURSAL</th>
                    <th>DESCRIPCIÓN</th>
                    <th>MONTO</th>
                    <th>TIPO DE GASTO</th>
                    <th>FECHA</th>
                  </tr>
                </thead>
                <tbody className="tbody-print">
                  {dataReporteGastos.map((data, i) => {
                    return (
                      <tr className="m-height-40">
                        <td>{data.gs_id}</td>
                        <td>{data.com_alias}</td>
                        <th>{data.gs_desc}</th>
                        <th>{Number(data.gs_monto).toFixed(2)}</th>
                        <td>{data.tgs_desc}</td>
                        <td>{data.gs_fecha}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Col>
          </Row>
        </React.Fragment>
      );
    }
  }
  class ComponentToPrintsReporteVentas extends React.Component {
    render() {
      var props = this.props.props;
      var form = this.props.objeData;
      var dataReporteVentasFpago = this.props.dataReporteVentasFpago;
      var formCompania = this.props.formCompania;
       var sucursalSelected =this.props.sucursalSelected;

      return (
        <React.Fragment>
  
          <Row key={new Date().toString()} className="datatable-rep">
            <Col xs={12}>
              <Row className="mt-2 border-rep-bot mb-3">
                <Col xs={3} className="text-center">
                  <img alt="" className="logo-rep top-unset" src={LOGO}></img>
                </Col>
                <Col xs={5} className="text-start mb-3">
                  <Label className="title-re">{formCompania.com_nombre}</Label><br></br>
                  <Label className="title-rep2">{"R.U.C. "+formCompania.com_ruc + " D.V. "+formCompania.com_dv}</Label><br></br>
                  <Label className="title-rep2">{formCompania.com_telefono + " / "+formCompania.com_email}</Label>
                  <Label className="title-rep2">{formCompania.com_direccion}</Label><br></br>
                </Col>
                <Col xs={4}></Col>
              </Row>
              <Row>
                <Col xs={12} className="text-start mb-2 MT-2">
                  <Label className="title-re">REPORTE DE VENTAS</Label><br></br>
                  <Label className="title-rep2">SUCURSAL : {sucursalSelected}</Label><br></br>
                  <Label className="title-rep2">FECHA :  {form.startDate} -  {form.Endate}</Label><br></br>
                </Col>
              </Row>
            </Col>


            <Col xs={12} className="text-center padding-print-body">
              <MDBTable striped className="custom-table">
                <MDBTableHead dark>
                  <tr>
                    <th className="text-center">N° DOCUMENTO</th>
                    <th className="text-center">FECHA</th>
                    <th className="text-center">CLIENTE</th>
                    <th className="text-center">VENDEDOR</th>
                    <th className="text-center">CAJA</th>
                    <th className="text-center">F. ANULADO</th>
                    <th className="text-center w-500px">EXENTO</th>
                    <th className="text-center">F. PAGO</th>
                    <th className="text-center">SUBTOTAL</th>
                    <th className="text-center">ITBMS</th>
                    <th className="text-center">TOTAL</th>
                  </tr>
                </MDBTableHead>
                <tbody className="tbody-print">
                  {props.map((data, i) => {
                    return (
                      <tr key={i}>
                        <td className="text-start">
                          <Label>{data.fac_id.toString().padStart(10, "0")}</Label>
                        </td>
                        <td className="text-center">
                          <Label>{data.fac_fecha}</Label>
                        </td>
                        <td className="text-start">
                          <Label>{data.cli_nombre}</Label>
                        </td>
                        <td className="text-start">
                          <Label>{data.usr_nombre}</Label>
                        </td>
                        <td className="text-center">
                          <Label>{data.fac_caja}</Label>
                        </td>
                        <td className="text-center">
                          <Label>{data.fac_date_anulacion}</Label>
                        </td>
                        <td className="text-center">
                          <Label>{data.fcd_itbms_code==="00"?"Exento":null}</Label>
                        </td>
                        <td className="text-start">
                                      {
                                      dataReporteVentasFpago.map((datap,i)=>{
                                          if(data.fac_id===datap.fac_id){
                                            return <><Label className="label-fpago">&nbsp;&nbsp;&nbsp;{datap.fcfp_pago}{" "} $ {format_miles({num:datap.fcfp_monto})}</Label></>
                                          }
                                          return null
                                      })
                                      }
                                    </td>
                        <td className="text-end">
                          <Label className="padding-r">$ {format_miles({num:data.fcd_precio})}</Label>
                        </td>
                        <td className="text-end">
                          <Label className="padding-r">$ {format_miles({num:data.fcd_itbms})}</Label>
                        </td>
                       
                        <td className="text-end">
                          <Label className="padding-r"> $ {format_miles({num:data.fcd_total})}</Label>
                        </td>
                      </tr>
                    );
                  })}
                  <tr className="border-0">
                    <td className="text-left font-weight-bold border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    {/* <td className="text-center"></td> */}
                    <td className="text-center border-0"></td>
   
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-left border-0">
                      <Label className="fw-bold">SUBTOTAL</Label>
                    </td>
                    <td className="text-end border-0">
                      <Label className="fw-bold">$ {format_miles({num:form.subtotal})}</Label>{" "}
                    </td>
                  </tr>
                  <tr className="border-0 border-0">
                    <td className="text-left font-weight-bold border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                 
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    {/* <td className="text-center"></td> */}
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-left border-0">
                      <Label className="fw-bold">EXENTO ITBMS</Label>
                    </td>
                    <td className="text-end border-0">
                      <Label className="fw-bold">$ {format_miles({num:form.exento})}</Label>{" "}
                    </td>
                  </tr>
                  <tr className="border-0">
                    <td className="text-left font-weight-bold border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                 
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    {/* <td className="text-center"></td> */}
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-left border-0">
                      <Label className="fw-bold">ITBMS</Label>
                    </td>
                    <td className="text-end border-0">
                      <Label className="fw-bold">$ {format_miles({num:form.itbms})} </Label>{" "}
                    </td>
                  </tr>
                  <tr className="border-0">
                    <td className="text-left font-weight-bold border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
    
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    <td className="text-center border-0"></td>
                    {/* <td className="text-center"></td> */}
                    <td className="text-center border-0"></td>
                    <td className="text-left border-0 ">
                      <Label className="fw-bold">TOTAL</Label>
                    </td>
                    <td className="text-end border-0">
                      <Label className="fw-bold">$ {format_miles({num:form.total})} </Label>{" "}
                    </td>
                  </tr>
                </tbody>
              </MDBTable>
            </Col>
          </Row>
        </React.Fragment>
      );
    }
  }
  class ComponentToPrintsReporteIC extends React.Component {
    render() {
      var formCompania = this.props.formCompania;
      var dataReporteInformeCaja = this.props.dataReporteInformeCaja;
      var sucursalSelected =this.props.sucursalSelected;
      var startDate = this.props.startDate;
      var endDate = this.props.endDate;
      var total_ventas_r = 0;
      var total_totales = 0;
      return (
        <React.Fragment>
          <Row key={new Date().toString()} className="datatable-rep">
                <Col xs={12}>
                  <Row className="mt-2 border-rep-bot mb-3">
                    <Col xs={3} className="text-center">
                      <img alt="" className="logo-rep top-unset" src={LOGO}></img>
                    </Col>
                    <Col xs={6} className="text-start">
                      <Label className="title-re">{formCompania.com_nombre}</Label><br></br>
                      <Label className="title-rep2">{"R.U.C. "+formCompania.com_ruc + " D.V. "+formCompania.com_dv}</Label><br></br>
                      <Label className="title-rep2">{formCompania.com_telefono + " / "+formCompania.com_email}</Label>
                      <Label className="title-rep2">{formCompania.com_direccion}</Label><br></br>
                    </Col>
                    <Col xs={3} className="text-end">
                    
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} className="text-start mb-2">
                      <Label className="title-re">REPORTE DE INFORMES DE CAJA</Label><br></br>
                      <Label className="title-rep2">SUCURSAL : {sucursalSelected}</Label><br></br>
                      <Label className="title-rep2">FECHA :  {startDate} -  {endDate}</Label><br></br>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} className="text-center padding-print-body">
                  <Label className="report-title">VENTAS REGISTRADAS</Label>
                  <MDBTable striped className="custom-table">
                    <MDBTableHead dark>
                          <tr>
                            <th>CAJA</th>
                            <th>FORMA DE PAGO</th>
                            <th>MONTO</th>
                          </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                          {
                            dataReporteInformeCaja.montos_fpago.map((data, i) => {
                              total_ventas_r = Number(total_ventas_r) + Number(data.fcfp_monto)
                              return <tr>
                                  <td className="text-start">{data.caj_descripcion}</td>
                                 <th className="text-end" ><Label className="padding-r">{data.fcfp_fpago}</Label></th>
                                <th className="text-end" ><Label className="padding-r"> $ {format_miles({num:data.fcfp_monto})}</Label></th>
                              </tr>
                            })
                          }
                          <tr>
                            <td></td>
                            <td></td>
                            <th className="text-end" ><Label className="padding-r"> TOTAL  $ {format_miles({num:total_ventas_r})}</Label></th>
                          </tr>
                        </MDBTableBody>
                  </MDBTable>
                </Col>
                <Col xs={12} className="text-center">
                  <Label className="report-title">TOTAL DE EXENTOS DE ITBMS</Label>
                  <MDBTable striped className="custom-table">
                    <MDBTableHead dark>
                      <tr>
                        <th className="text-center">TOTAL</th>
                      </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                      {
                        dataReporteInformeCaja.exentos.map((data, i) => {
                          return <tr>
                            <td className="text-center">$ {format_miles({num:data.fcd_total})}</td>
                          </tr>
                        })
                      }
                    </MDBTableBody>
                  </MDBTable>
                </Col>
                <Col xs={12} className="text-center">
                  <Label className="report-title">ANULACIONES REGISTRADAS</Label>
                  <MDBTable striped className="custom-table">
                    <MDBTableHead dark>
                      <tr>
                        <th>CAJA</th>
                        <th>VENDEDOR</th>
                        <th>NÚMERO DE DOCUMENTO</th>
                        <th>EMITIDO</th>
                        <th>ANULADO</th>
                        <th>TOTAL</th>
                        <th>MOTIVO</th>
                      </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                      {
                        dataReporteInformeCaja.anulacion.map((data, i) => {
                          return <tr>
                            <th className="text-start">{data.caj_descripcion}</th>
                            <th  className="text-start">{data.usr_nombre}</th>
                            <td  className="text-start">{data.fac_id}</td>
                            <th  className="text-start">{data.fac_fecha}</th>
                            <td className="text-start">{data.fac_date_anulacion}</td>
                            <th className="text-end"><Label className="padding-r"> $ {format_miles({num:data.fcd_total})}</Label></th>
                            <td  className="text-start">{data.fac_motivo_anulacion}</td>
                          </tr>
                        })
                      }
                    </MDBTableBody>
                  </MDBTable>
                </Col>
                <Col xs={12} className="text-center">
                  <Label className="report-title">TOTALES</Label>
                  <MDBTable striped className="custom-table">
                    <MDBTableHead  dark>
                      <tr>
                        <th>CAJA</th>
                        <th>VENTAS SUBTOTAL</th>
                        <th>VENTAS EXENTO</th>
                        <th>ITBMS</th>
                        <th>TOTAL</th>
                      </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                      {
                        dataReporteInformeCaja.montos_totales.map((data, i) => {
                            total_totales = Number(total_totales) + Number(data.fcd_total)
                          return <tr>
                            <td className="text-start">{data.caj_descripcion}</td>
                            <td className="text-end" ><Label className="padding-r"> $ {format_miles({num:data.fcd_precio})}</Label></td>
                            <td className="text-end"><Label className="padding-r"> $ {format_miles({num:dataReporteInformeCaja.exentos[0].fcd_total})}</Label></td>
                            <td className="text-end"><Label className="padding-r"> $ {format_miles({num:data.fcd_itbms})}</Label></td>
                            <th className="text-end"><Label className="padding-r"> $ {format_miles({num:data.fcd_total})}</Label></th>
                          </tr>
                        })
                      }
                      <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th>TOTAL</th>
                         <th className="text-end"><Label className="padding-r"> $ {format_miles({num:total_totales})}</Label></th>
                      </tr>
                    </MDBTableBody>
                  </MDBTable>
                </Col>
          </Row>
        </React.Fragment>
      );
    }
  }
  class ComponentToPrintsRecuento extends React.Component {
    render() {
      var props = this.props.props;
      var formRecuento = this.props.formRecuento;
      var formCompania = this.props.formCompania;
      var n_articulo = 0;
      return (
        <React.Fragment>
          <Row key={new Date().toString()} className="datatable-rep">
            <Col xs={12}>
              <Row className="mt-2 border-rep-bot mb-3">
                <Col xs={3} className="text-center">
                  <img alt="" className="logo-rep" src={LOGO}></img>
                </Col>
                <Col xs={6} className="text-start">
                  <Label className="title-re">{formCompania.com_nombre}</Label><br></br>
                  <Label className="title-rep2">{"R.U.C. "+formCompania.com_ruc + " D.V. "+formCompania.com_dv}</Label><br></br>
                  <Label className="title-rep2">{formCompania.com_telefono + " / "+formCompania.com_email}</Label>
                  <Label className="title-rep2">{formCompania.com_direccion}</Label><br></br>
                </Col>
                <Col xs={3} className="text-end">
                 <Label className="title-rep3">N° {formRecuento.re_id}</Label><br></br>
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="text-start mb-2">
                  <Label className="title-re">INVENTARIO</Label><br></br>
                  <Label className="title-rep2"># DE DOCUMENTO : {formRecuento.re_id}</Label><br></br>
                  {/* <Label className="title-rep2">BODEGA : {props[0].bod_nombre}</Label><br></br> */}
                  <Label className="title-rep2">DESCRIPCIÓN: {formRecuento.re_descripcion}</Label><br></br>
                  <Label className="title-rep2">FECHA DOCUMENTO PROCESADO: {formRecuento.re_fecha_procesado}</Label><br></br>
                </Col>
              </Row>
            </Col>

            <Col xs={12} className="text-center padding-print-body">
              <MDBTable striped className="custom-table">
                <MDBTableHead dark>
                  <tr>
                    <th className="text-center w-300px">CÓDIGO</th>
                    <th className="text-center w-300px">ARTÍCULO</th>
                    <th className="text-center w-300px">MARCA</th>
                    <th className="text-center w-300px">PROVEEDOR</th>
                    <th className="text-center w-300px">COSTO</th>
                    <th className="text-center w-300px">PRECIO</th>
                    <th className="text-center w-300px">CONTEO</th>
                  </tr>
                </MDBTableHead>
                <MDBTableBody className="datatable-body">
                  {props.map((data, i) => {
                    n_articulo = Number(n_articulo) + 1
                    return (
                      <tr key={i}>
                        <td className="text-left">
                          <Label>{data.art_upc}</Label>
                        </td>
                        <td className="text-left">
                          <Label>{data.art_descripcion}</Label>
                        </td>
                        <td className="text-left">
                          <Label>{data.mar_descripcion}</Label>
                        </td>
                        <td className="text-left">
                          <Label>{data.prov_nombre}</Label>
                        </td>
                        <td className="text-left">
                          <Label>{(Number(data.art_costo)*Number(data.art_itbm_compra)).toFixed(2)}</Label>
                        </td>
                        <td className="text-left">
                          <Label>{data.art_precio}</Label>
                        </td>
                        <td className="text-center">
                          <Label>{data.red_cantidad}</Label>
                        </td>
                      </tr>
                    );
                   
                  })}
                </MDBTableBody>
              </MDBTable>
            </Col>
          </Row>
        </React.Fragment>
      );
    }
  }
  class ComponentToPrintsRecuentoMoviento extends React.Component {
    render() {
      var props = this.props.props;
      return (
        <React.Fragment>
          <Row key={new Date().toString()}>
            <Col xs={12} className="text-center">
              <img alt="" className="width-logo" src={LOGO}></img>
            </Col>
  
            <Col xs={12} className="text-start padding-print-body">
              <h3 className="fw-bold text-center ">Movimiento </h3>
              <Label className="fw-bold">
                Fecha de impresion : {moment(new Date()).format("YYYY-MM-DD")}
              </Label>
              <br></br>
            </Col>
            <Col xs={12} className="text-center padding-print-body">
              <table className="table table-bordered ">
                <thead>
                  <tr>
                    <th className="text-center w-300px">Codigo</th>
                    <th className="text-center w-300px">Descripcion</th>
                    <th className="text-center w-300px">Categoria</th>
                    <th className="text-center w-300px">Marca</th>
                    <th className="text-center w-300px">Cantidad en existencia</th>
                  </tr>
                </thead>
                <tbody className="tbody-print">
                  {props.map((data, i) => {
                    return (
                      <tr key={i}>
                        <td className="text-center">
                          <Label>{data.art_upc}</Label>
                        </td>
                        <td className="text-center">
                          <Label>{data.art_descripcion}</Label>
                        </td>
                        <td className="text-center">
                          <Label>{data.art_categoria}</Label>
                        </td>
                        <td className="text-center">
                          <Label>{data.art_marca}</Label>
                        </td>
                        <td className="text-center">
                          <Label>{data.art_linea_roja}</Label>
                        </td>
                        <td className="text-center">
                          <Label>{data.inv_qty}</Label>
                        </td>
                      </tr>
                    );
                   
                  })}
                </tbody>
              </table>
            </Col>
          </Row>
        </React.Fragment>
      );
    }
  }
  class ComponentToPrintsReporteVM extends React.Component {
    render() {
      var formCompania = this.props.formCompania;
      var dataReportVentasMensuales = this.props.dataReportVentasMensuales;
      var startDate = this.props.startDate;
      var endDate = this.props.endDate;
      var sucursalSelected =this.props.sucursalSelected;
      return (
        <React.Fragment>
          <Row key={new Date().toString()} className="datatable-report">
            <Col xs={12} className="text-center">
              <img alt="" className="width-logo" src={LOGO}></img>
            </Col>
  <Col xs={12}>
  <Col xs={12} className="text-center mt-4 mb-2">
                    <h3 className="font-weight-bold">
                      {formCompania.com_nombre}
                    </h3>
                    <h7>{formCompania.com_direccion}</h7><br></br>
                    <h7 className="font-weight-bold">
                    {"RUC: "+formCompania.com_ruc + " DV "+formCompania.com_dv}
                    </h7><br></br>
                    <h7 className="font-weight-bold">
                    {"TEL: "+formCompania.com_telefono}
                    </h7>
                  </Col>
  <>
                        <Row>
                          <Col xs={12} className="text-center mt-3">
                          <h5 className="text-center ">REPORTE DE VENTAS MENSUALES</h5>
                          </Col>
                          <Col  xs={12} className="text-start">
                          <Label className="report-title">{ <p className="date-p-label float-right-btn">Fecha : {" "}
                        {moment(startDate).format("YYYY-MM-DD")} {" - "}
                        {moment(endDate).format("YYYY-MM-DD")}
                      </p>}</Label><br></br>
                      <Label className="report-title">{ <p className="date-p-label float-right-btn">Sucursal : {" "}
                        {sucursalSelected}
                      </p>}</Label></Col>

                          <Col xs={12} className="text-left">
              
                            <MDBTable striped className="custom-table">
                              <MDBTableHead dark>
                                <tr>
                                  <th>Mes</th>
                                  <th>ITBMS</th>
                                  <th>Monto</th>
                                </tr>
                              </MDBTableHead>
                              <MDBTableBody>
                                {
                                  dataReportVentasMensuales.map((data, i) => {
                                    return <tr>
                                      <th>{data.label}</th>
                                      <th>{data.itbms}</th>
                                      <td>{data.result}</td>
                                    </tr>
                                  })
                                }
                              </MDBTableBody>
                            </MDBTable>
                          </Col>
                        </Row>
                      </>
  </Col>
          </Row>
        </React.Fragment>
      );
    }
  }
  class ComponentToPrintsReportePVM extends React.Component {
    render() {
      var dataReporProductosVendidos = this.props.dataReporProductosVendidos;
      var startDate = this.props.startDate;
      var endDate = this.props.endDate;
      var formCompania = this.props.formCompania;
      return (
        <React.Fragment>
          <Row key={new Date().toString()} className="datatable-report">
            <Col xs={12} className="text-center">
              <img alt="" className="width-logo" src={LOGO}></img>
            </Col>
  <Col xs={12}>
  <Col xs={12} className="text-center mt-4 mb-2">
                    <h3 className="font-weight-bold">
                      {formCompania.com_nombre}
                    </h3>
                    <h7>{formCompania.com_direccion}</h7><br></br>
                    <h7 className="font-weight-bold">
                    {"RUC: "+formCompania.com_ruc + " DV "+formCompania.com_dv}
                    </h7><br></br>
                    <h7 className="font-weight-bold">
                    {"TEL: "+formCompania.com_telefono}
                    </h7>
                  </Col>
  <>
                        <Row>
                          <Col xs={12} className="text-center mt-4">
                          <h5 className="text-center ">REPORTE DE PRODUCTOS MÁS VENDIDOS</h5>
                          </Col>
                          <Col  xs={12} className="text-start">
                          <Label className="report-title">{ <p className="date-p-label float-right-btn">Fecha : {" "}
                        {moment(startDate).format("YYYY-MM-DD")} {" - "}
                        {moment(endDate).format("YYYY-MM-DD")}
                      </p>}</Label></Col>
                          <Col xs={12} className="text-left">
              
                            <MDBTable striped className="custom-table">
                              <MDBTableHead dark>
                                <tr>
                                  <th>UPC</th>
                                  <th>Artículo</th>
                                  <th>Marca</th>
                                  <th>Categoría</th>
                                  <th>Cantidad</th>
                                </tr>
                              </MDBTableHead>
                              <MDBTableBody>
                                {
                                  dataReporProductosVendidos.map((data, i) => {
                                    return <tr>
                                       <td>{data.art_upc}</td>
                                      <td>{data.art_descripcion}</td>
                                      <th>{data.mar_descripcion}</th>
                                      <th>{data.cat_descripcion}</th>
                                      <td>{data.cantidad}</td>
                                    </tr>
                                  })
                                }
                              </MDBTableBody>
                            </MDBTable>
                          </Col>
                        </Row>
                      </>
  </Col>
          </Row>
        </React.Fragment>
      );
    }
  }
    class ComponentToPrintsReportePV extends React.Component {
    render() {
      var dataReporProductosVendidos = this.props.dataReporProductosVendidos;
      var startDate = this.props.startDate;
      var endDate = this.props.endDate;
      var formCompania = this.props.formCompania;
      return (
        <React.Fragment>
          <Row key={new Date().toString()} className="datatable-report">
            <Col xs={12}>
              <Row className="mt-2 border-rep-bot mb-3">
                <Col xs={3} className="text-center">
                  <img alt="" className="logo-rep" src={LOGO}></img>
                </Col>
                <Col xs={6} className="text-start">
                  <Label className="title-re">{formCompania.com_nombre}</Label><br></br>
                  <Label className="title-rep2">{"R.U.C. "+formCompania.com_ruc + " D.V. "+formCompania.com_dv}</Label><br></br>
                  <Label className="title-rep2">{formCompania.com_telefono + " / "+formCompania.com_email}</Label>
                  <Label className="title-rep2">{formCompania.com_direccion}</Label><br></br>
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="text-start mb-2">
                  <Label className="title-re">REPORTE DE PRODUCTOS VENDIDOS</Label><br></br>
                  <Label className="title-rep2">FECHA: {moment(startDate).format("YYYY-MM-DD")} {" - "} {moment(endDate).format("YYYY-MM-DD")}</Label><br></br>
                </Col>
              </Row>
            </Col>  <>
            <Row>
              <Col xs={12} className="text-left ">
                <MDBTable striped className="custom-table">
                  <MDBTableHead dark>
                    <tr>
                    <th>CÓDIGO</th>
                    <th>Artículo</th>
                    <th>Categoría</th>
                    <th>Fecha</th>
                    <th>Caja</th>
                    <th>Vendedor</th>
                    <th>Cantidad</th>
                    <th>Costo</th>
                    <th>Precio</th>
                    <th>ITBMS</th>
                    <th>C. Total</th>
                    <th>T. Venta</th>
                    <th>Utilidad</th>
                    </tr>
                  </MDBTableHead>
                  <MDBTableBody className="datatable-body">
                    {
                      dataReporProductosVendidos.map((data, i) => {
                        return <tr>
                          <td>{data.art_upc}</td>
                          <td>{data.art_descripcion}</td>
                            <td>{data.cat_descripcion}</td>
                          <td>{FORMATO_AM_PM(new Date(data.fac_fecha))}</td>
                          <th>{data.caj_descripcion}</th>
                          <th>{data.usr_nombre}</th>
                          <td>{data.cantidad}</td>
                          <td>{Number(Number(data.art_costo)*(1+Number(data.art_itbm_compra))).toFixed(2)}</td>
                          <td>{data.fcd_precio}</td>
                          <td>{ Number(data.fcd_itbms).toFixed(2)}</td>
                          <td>{Number((Number(data.art_costo)*Number(data.cantidad))*(1+Number(data.art_itbm_compra))).toFixed(2)}</td>
                          <td>{Number(data.fac_total).toFixed(2)}</td>
                          <td>{(Number(data.fac_total)-((Number(data.art_costo)*Number(data.cantidad))*(1+Number(data.art_itbm_compra)))).toFixed(2) }</td>
                        </tr>
                      })
                    }
                  </MDBTableBody>
                </MDBTable>
              </Col>
                        </Row>
                      </>
          </Row>
        </React.Fragment>
      );
    }
  }
  class ComponentToPrintsReporteUM extends React.Component {
    render() {
      var dataReportUtilidadMargen = this.props.dataReportUtilidadMargen;
      var startDate = this.props.startDate;
      var endDate = this.props.endDate;
      var formCompania = this.props.formCompania;
      return (
        <React.Fragment>
          <Row key={new Date().toString()} className="datatable-report">
            <Col xs={12} className="text-center">
              <img alt="" className="width-logo" src={LOGO}></img>
            </Col>
  <Col xs={12}>
  <Col xs={12} className="text-center mt-4 mb-2">
                    <h3 className="font-weight-bold">
                      {formCompania.com_nombre}
                    </h3>
                    <h7>{formCompania.com_direccion}</h7><br></br>
                    <h7 className="font-weight-bold">
                    {"RUC: "+formCompania.com_ruc + " DV "+formCompania.com_dv}
                    </h7><br></br>
                    <h7 className="font-weight-bold">
                    {"TEL: "+formCompania.com_telefono}
                    </h7>
                  </Col>
  <>
                        <Row>
                          <Col xs={12} className="text-center mt-3">
                          <h5 className="text-center ">REPORTE DE UTLIDAD Y MARGEN</h5>
                          </Col>
                          <Col  xs={12} className="text-start">
                          <Label className="report-title">{ <p className="date-p-label float-right-btn">Fecha : {" "}
                        {moment(startDate).format("YYYY-MM-DD")} {" - "}
                        {moment(endDate).format("YYYY-MM-DD")}
                      </p>}</Label></Col>
                          <Col xs={12} className="text-left">
              
                            <MDBTable striped className="custom-table">
                              <MDBTableHead dark>
                                <tr>
                                <th>CÓDIGO</th>
                                <th>Artículo</th>
                                <th>CANTIDAD</th>
                                <th>COSTO</th>
                                <th>TOTAL</th>
                                <th>UTILIDAD</th>
                                <th>MARGEN</th>
                                </tr>
                              </MDBTableHead>
                              <MDBTableBody>
                                {
                                  dataReportUtilidadMargen.map((data, i) => {
                                    return <tr>
                                      <td>{data.art_upc}</td>
                                      <td>{data.art_descripcion}</td>
                                      <th>{Number(data.fcd_cantidad).toFixed(2)}</th>
                                      <th>{Number(data.art_costo).toFixed(2)}</th>
                                      <td>{Number(data.art_total).toFixed(2)}</td>
                                      <td>{(Number(data.art_total)-Number(data.art_costo)).toFixed(2)}</td>
                                      <td>{((Number(data.art_total)-Number(data.art_costo))/Number(data.art_total)*100).toFixed(2)+"%"}</td>
                                    </tr>
                                  })
                                }
                              </MDBTableBody>
                            </MDBTable>
                          </Col>
                        </Row>
                      </>
  </Col>
          </Row>
        </React.Fragment>
      );
    }
  }
  class ComponentToPrintsReporteInventarioEx extends React.Component {
    render() {
      var dataExistenciaInv = this.props.dataExistenciaInv;
      var formCompania = this.props.formCompania;
      var n_item = 0;
      dataExistenciaInv.map(data=>{
        n_item = n_item+1;
      })
      return (
        <React.Fragment>
          <Row key={new Date().toString()} className="datatable-rep">
            <Col xs={12}>
              <Row className="mt-2 border-rep-bot mb-3">
                <Col xs={3} className="text-center">
                  <img alt="" className="logo-rep" src={LOGO}></img>
                </Col>
                <Col xs={9} className="text-start">
                  <Label className="title-re">{formCompania.com_nombre}</Label><br></br>
                  <Label className="title-rep2">{"R.U.C. "+formCompania.com_ruc + " D.V. "+formCompania.com_dv}</Label><br></br>
                  <Label className="title-rep2">{formCompania.com_telefono + " / "+formCompania.com_email}</Label><br></br>
                  <Label className="title-rep2">{formCompania.com_direccion}</Label><br></br>
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="text-start mb-2">
                  <Label className="title-re">REPORTE DE INVENTARIO</Label><br></br>
                  <Label className="title-rep2">FECHA: {moment(new Date()).format("YYYY-MM-DD HH:mm:ss")}</Label><br></br>
                  <Label className="title-rep2">CANTIDAD DE ARTÍCULOS : {n_item}</Label>
                </Col>
                <Col xs={12} className="text-left">
                  <MDBTable striped className="custom-table">
                    <MDBTableHead dark>
                      <tr>
                        <th className="text-center">CÓDIGO</th>
                        <th className="text-center">ARTÍCULO</th>
                        <th className="text-center">CATEGORIA</th>
                        <th className="text-center">MARCA</th>
                        <th className="text-center">CANTIDAD</th>
                      </tr>
                    </MDBTableHead>
                    <MDBTableBody className="datatable-body">
                      {
                        dataExistenciaInv.map((data, i) => {
                          return <tr>
                            <td>{data.art_upc}</td>
                            <td>{data.art_descripcion}</td>
                            <td>{data.art_categoria}</td>
                            <td>{data.art_marca}</td>
                            <th>{data.inv_qty}</th>
                          </tr>
                        })
                      }
                    </MDBTableBody>
                  </MDBTable>
                </Col>
              </Row>
             
            </Col>
          </Row>
        </React.Fragment>
      );
    }
  }
  class ComponentToPrintsBarcode extends React.Component {
    render() {
      var formArticulos = this.props.formArticuloss;
      return (
        <Row className="barcode-box mt-5 mb-5">
          <Col xs={12} className="text-center">
          <ReactBarcode value={formArticulos.art_upc} options={{format: 'code128',textPosition:"top",text:formArticulos.art_upc, width:1.7,height:25, textMargin:1,fontSize:16,margin:0 }} renderer="svg"/>
         <Label className="barcode-text">{formArticulos.art_descripcion.substring(0,65)}</Label> <br></br>
         <Label className="barcode-text2">{"$"+(new Decimal(formArticulos.art_precio).times(new Decimal(formArticulos.art_itbm_venta).plus(new Decimal(1))).toDecimalPlaces(2,Decimal.ROUND_UP)).toFixed(2)}</Label> 
          </Col>
        </Row>
        
      );
    }
  }
  class ComponentToPrintsReporteCreditos extends React.Component {
    render() {
      var formCompania = this.props.formCompania;
      var dataReporteCreditos = this.props.dataReporteCreditos;
      var dataReporteCreditosPago = this.props.dataReporteCreditosPago;
      var sucursalSelected =this.props.sucursalSelected;
      var startDate =  this.props.startDate
      var  endDate = this.props.endDate
      return (
        <React.Fragment>
          <Row key={new Date().toString()} className="datatable-rep">
            <Col xs={12}>
              <Row className="mt-2 border-rep-bot mb-3">
                <Col xs={3} className="text-center">
                  <img alt="" className="logo-rep top-unset" src={LOGO}></img>
                </Col>
                <Col xs={6} className="text-start">
                  <Label className="title-re">{formCompania.com_nombre}</Label><br></br>
                  <Label className="title-rep2">{"R.U.C. "+formCompania.com_ruc + " D.V. "+formCompania.com_dv}</Label><br></br>
                  <Label className="title-rep2">{formCompania.com_telefono + " / "+formCompania.com_email}</Label>
                  <Label className="title-rep2">{formCompania.com_direccion}</Label><br></br>
                </Col>
                <Col xs={3} className="text-end">
                
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="text-start mb-2">
                  <Label className="title-rep2">SUCURSAL: {sucursalSelected}</Label><br></br>
                    <Label className="title-rep2">FECHA :  {startDate} -  {endDate}</Label><br></br>
                </Col>
              </Row>
            </Col>
            <Col xs={12} className="text-center padding-print-body">
              <MDBTable striped className="custom-table">
                <MDBTableHead dark>
                                <tr>
                                  <th># FACTURA</th>
                                  <th>CLIENTE</th>
                                  <th>RUC</th>
                                  <th>MONTO</th>
                                  <th>FECHA</th>
                                </tr>
                              </MDBTableHead>
                              <MDBTableBody>
                                {
                                  dataReporteCreditos.map((data, i) => {
                                    return <tr>
                                      <th className="text-start">{data.fac_id.toString().padStart(10, "0")}</th>
                                      <td className="text-start">{data.cli_nombre}</td>
                                      <th className="text-start">{data.cli_ruc}</th>
                                      <td className="text-end">$ { format_miles({num:data.crd_monto})}</td>
                                      <th>{data.crd_fecha}</th>
                                    </tr>
                                  })
                                }
                              </MDBTableBody>
                            </MDBTable>

                          </Col>
                          <Col xs={12} className="text-center mt-3">
                          <h5 className="text-center ">REPORTE DE PAGO A CRÉDITOS</h5>
                          </Col>
                          <Col xs={12} className="text-center">
                          <MDBTable striped className="custom-table">
                              <MDBTableHead dark>
                                <tr>
                                  <th># FACTURA</th>
                                  <th>CLIENTE</th>
                                  <th>RUC</th>
                                  <th>MONTO</th>
                                  <th>FECHA PAGO</th>
                                  <th>FECHA ELIMINADO</th>
                                </tr>
                              </MDBTableHead>
                              <MDBTableBody>
                                {
                                  dataReporteCreditosPago.map((data, i) => {
                                    return <tr>
                                      <td className="text-start">{data.fac_id.toString().padStart(10, "0")}</td>
                                      <td className="text-start">{data.cli_nombre}</td>
                                      <td className="text-start">{data.cli_ruc}</td>
                                      <td className="text-end">$ { format_miles({num:data.crp_monto})}</td>
                                      <td className="text-center">{data.crp_fecha}</td>
                                      <td className="text-center">{data.crp_fecha_delete}</td>
                                    </tr>
                                  })
                                }
                              </MDBTableBody>
                            </MDBTable>

                          </Col>
                        </Row>

        </React.Fragment>
      );
    }
  }
   class ComponentToPrintsReporteMovimientos extends React.Component {
    render() {
      var props = this.props.props;
      var formMovimiento = this.props.formMovimiento;
      var formCompania = this.props.formCompania;
      var subtotal = 0;
      var itbms = 0;
      var total = 0;
      return (
        <React.Fragment>
          <Row key={new Date().toString()} className="datatable-rep">
            <Col xs={12}>
              <Row className="mt-2 border-rep-bot mb-3">
                <Col xs={3} className="text-center">
                  <img alt="" className="logo-rep" src={LOGO}></img>
                </Col>
                <Col xs={7} className="text-start">
                  <Label className="title-re">{formCompania.com_nombre}</Label><br></br>
                  <Label className="title-rep2">{"R.U.C. "+formCompania.com_ruc + " D.V. "+formCompania.com_dv}</Label><br></br>
                  <Label className="title-rep2">{formCompania.com_telefono + " / "+formCompania.com_email}</Label>
                  <Label className="title-rep2">{formCompania.com_direccion}</Label><br></br>
                </Col>
                <Col xs={2} className="text-end">
                 <Label className="title-rep3">N° {formMovimiento.mov_id}</Label><br></br>
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="text-start mb-2">
                  <Label className="title-re">MOVIMIENTO</Label><br></br>
                  <Label className="title-rep2"># DE DOCUMENTO : {formMovimiento.mov_id}</Label><br></br>
                  <Label className="title-rep2">FECHA : {moment(formMovimiento.mov_fecha).format("YYYY-MM-DD")}</Label><br></br>
                  <Label className="title-rep2">DESCRIPCIÓN : {formMovimiento.mov_descripcion}</Label><br></br>
                  <Label className="title-rep2">BODEGA SALE: {formMovimiento.mov_bodega_desde_nombre}</Label><br></br>
                  <Label className="title-rep2">BODEGA ENTRA: {formMovimiento.mov_bodega_hacia_nombre}</Label><br></br>
                </Col>
              </Row>
            </Col>
            <Col xs={12} className="text-center padding-print-body">
              <MDBTable striped className="custom-table">
                <MDBTableHead dark>
                  <tr>
                    <th className="text-center w-300px">Código</th>
                    <th className="text-center w-300px">Descripcion</th>
                    <th className="text-center w-300px">Cantidad</th>
                  </tr>
                </MDBTableHead>
                <MDBTableBody className="datatable-body">
                  {props.map((data, i) => {
                    subtotal =Number(subtotal) + Number(Number(data.dcd_cantidad) * Number(data.dcd_precio));
                    itbms = Number(itbms) + Number(data.dcd_itbms);
                    total = Number( subtotal) + Number(itbms);

                    return (
                      <tr key={i}>
                        <td className="text-start">
                          <Label>{data.art_upc}</Label>
                        </td>
                        <td className="text-start">
                          <Label>{data.art_descripcion}</Label>
                        </td>
                        <td className="text-center">
                          <Label>{data.movd_cantidad}</Label>
                        </td>
                      </tr>
                    );
                  })}
                </MDBTableBody>
              </MDBTable>
            </Col>
          </Row>
        </React.Fragment>
      );
    }
  }
  export {
    ComponentToPrintsReporteMovimientos,
    ComponentToPrintsReporteInventarioEx,
    ComponentToPrintsPDFCredito,
    ComponentToPrintsReporteCreditos,
    ComponentToPrintss,
    Componentprint_report_x,
    ComponentToPrintsCotizacion,
    ComponentToPrintsReporteVentas,
    ComponentToPrintsReporteIC,
    ComponentToPrintsRecuento,
    ComponentToPrintsRecuentoMoviento,
    ComponentToPrintsReporteVM,
    ComponentToPrintsBarcode,
    ComponentToPrintsReportePVM,
    ComponentToPrintsReporteUM,
    ComponentToPrintsReportePV,
    ComponentToPrintsGastos,
    printReceipt_bluetooth
  }